import { FunctionComponent, memo } from 'react';
import { IconLabel, QuoteBlockData, getCssVar, useLinkify } from '../../../../shared';

import classes from './Quote.module.scss';

export const Quote: FunctionComponent<QuoteBlockData> = memo(({ text, caption, alignment }) => {
  const { linkify } = useLinkify();

  return (
    <div className={classes['quote']} style={{ textAlign: alignment }}>
      <IconLabel
        className={classes['quote__image']}
        iconId={'quote'}
        color={getCssVar('--details-block-quote-icon-color')}
        singleColor
        nonClickable
      />
      {text && (
        <div
          className={classes['quote__text']}
          dangerouslySetInnerHTML={{ __html: linkify(text) }}
        ></div>
      )}
      {caption && (
        <div
          className={classes['quote__caption']}
          dangerouslySetInnerHTML={{ __html: linkify(caption) }}
        ></div>
      )}
    </div>
  );
});
